// Words for an account or organisation role, so a badge never prints the raw enum ("ADMIN").
// roleLabel() in utils/labels.js looks a role up here (any case, any separator).
// The CRM team roles (Sales, Call center, Control ...) are in teams.roleName.* and roleLabel()
// falls through to them.
const roles = {
  en: {
    admin: 'Admin',
    moderator: 'Moderator',
    teacher: 'Teacher',
    mentor: 'Mentor',
    student: 'Student',
    orgAdmin: 'Org admin',
    learner: 'Learner',
  },
  ru: {
    admin: 'Администратор',
    moderator: 'Модератор',
    teacher: 'Преподаватель',
    mentor: 'Ментор',
    student: 'Студент',
    orgAdmin: 'Админ организации',
    learner: 'Учащийся',
  },
  uz: {
    admin: 'Admin',
    moderator: 'Moderator',
    teacher: "O'qituvchi",
    mentor: 'Mentor',
    student: "O'quvchi",
    orgAdmin: 'Tashkilot admini',
    learner: "O'quvchi",
  },
};

export default roles;
